// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"0c79ee01","453":"e7b01a1a","667":"b094dc4c"}[chunkId] + ".chunk.js";
};